<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col
        cols="12"
        md="4"
      >
        <material-card
          :loading="loadingSettings"
          class="v-card-profile"
          color="primary"
        >
          <template v-slot:header>
            <div
              class="pa-3"
            >
              <h4
                class="title font-weight-light"
              >
                Mail
              </h4>
            </div>

            <v-spacer />
            <v-btn
              v-if="isBetaCore(user)"
              color="secondary"
              class="mr-3"
              @click="editSettings"
            >
              <v-icon class="pr-3">
                mdi-cog
              </v-icon>Edit Settings
            </v-btn>
          </template>
          <material-notification
            v-if="!loadingSettings && !settings.host || message"
            class="mb-3"
            :color="message ? 'success' : 'error'"
            icon="mdi-information-outline"
          >
            {{ message? message : 'No mail settings have been set for this site. Contact BetaCore to use mail.' }}
          </material-notification>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <template v-for="(email ,i ) in emails">
              <v-row
                :key="i"
                align="center"
                class="mb-2 mx-0"
                :style="'border: 1px solid; border-color: ' + $vuetify.theme.themes.dark.primary"
              >
                <v-col cols="8">
                  <h6 class="overline">
                    Email {{ i + 1 }}
                  </h6>
                </v-col>
                <v-col
                  cols="4"
                  class="text-right"
                >
                  <v-btn
                    icon
                    @click="() => removeEmail(i)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-col>
                <v-col
                  class="py-0"
                  cols="12"
                >
                  <v-text-field
                    v-model="email.name"
                    label="Name"
                  />
                </v-col>
                <v-col
                  class="py-0"
                  cols="12"
                >
                  <v-text-field
                    v-model="email.email"
                    :rules="emailRules"
                    label="Email"
                  />
                </v-col>
              </v-row>
            </template>
            <v-row class="my-4 mx-0">
              <v-btn
                color="primary"
                class="mr-3"
                block
                @click="addEmail"
              >
                <v-icon class="pr-3">
                  mdi-plus
                </v-icon>Add Email Address
              </v-btn>
            </v-row>
            <v-form-base
              :model="mail"
              :col="{ cols:12 }"
              :schema="mailSchema"
              @change="change"
            />
          </v-form>
          <template v-slot:actions>
            <v-spacer />
            <v-btn
              color="primary"
              @click="sendMail"
            >
              Send Mail
            </v-btn>
          </template>
        </material-card>
      </v-col>
      <v-col
        v-if="html"
        class="text-center"
        cols="12"
        md="8"
      >
        <iframe
          scrolling="no"
          frameBorder="0"
          style="min-width: 560px;"
          height="900"
          :srcdoc="html"
          no
        />
      </v-col>
    </v-row>
    <form-dialog
      ref="dialog"
      :title="'Edit Settings'"
      :schema="settingsSchema"
      :item="settings"
      @submit="submitSettings"
    />
    <yes-no-dialog
      ref="yesno"
      @yes="currentSend"
    />
  </v-container>
</template>

<script>
  import moment from 'moment'
  import FormDialog from '../components/core/FormDialog.vue'
  import VFormBase from 'vuetify-form-base'
  import YesNoDialog from '../components/core/YesNoDialog.vue'
  export default {
    components: {
      FormDialog,
      VFormBase,
      YesNoDialog
    },
    data () {
      return {
        valid: true,
        settings: {},
        dialog: false,
        loadingSettings: false,
        sendingMail: false,
        mail: {},
        emails: [{}],
        html: null,
        message: null,
        currentSend: () => {},
        emailRules: [
          v => !!v || 'Email is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid',
        ],
        mailSchema: {
          subject: {
            type: 'text',
            label: 'Subject'
          },
          greeting: {
            type: 'text',
            label: 'Greeting'
          },
          text: {
            type: 'text',
            label: 'Text',
          },
          button_text: {
            type: 'text',
            label: 'Button Text'
          },
          button_url: {
            type: 'text',
            label: 'Button URL'
          },
          bye: {
            type: 'text',
            label: 'Bye'
          },
          person: {
            type: 'text',
            label: 'Person'
          }
        },
        settingsSchema: {
          host: {
            type: 'text',
            label: 'Host'
          },
          port: {
            type: 'number',
            label: 'Port'
          },
          email: {
            type: 'email',
            label: 'Email'
          },
          password: {
            type: 'password',
            appendIcon: 'mdi-eye',
            label: 'Password'
          },
          fromEmail: {
            type: 'email',
            label: 'From Email'
          },
          fromName: {
            type: 'text',
            label: 'From Name'
          },
          html: {
            type: 'text',
            label: 'HTML'
          }
        },
      }
    },
    computed: {
      site: function () {
        return this.$store.state.site
      },
      user: function () {
        return this.$store.state.user
      }
    },
    mounted () {
      this.mail = {
        person: this.user.name,
        greeting: 'Dear {{name}}',
        text: 'This is the text of an email that will be send to {{email}} on {{date}}.',
        bye: 'Best regards'
      }
      this.getSettings()
    },
    methods: {
      moment,
      addEmail () {
        this.emails.push({
        })
      },
      removeEmail (i) {
        this.emails.splice(i, 1)
      },
      editSettings () {
        this.$refs.dialog.open()
      },
      getSettings () {
        if (this.site) {
          this.loadingSettings = true
          this.api.get('mail/settings/' + this.site)
            .then(result => {
              var settings = result.data
              if (settings) {
                this.settings = settings
                this.setHTML()
              }
              this.loadingSettings = false
            }, error => {
              this.loadingSettings = false
              this.error = error
            })
        }
      },
      change () {
        this.setHTML()
      },
      setHTML () {
        if (this.settings.html) {
          var html = this.settings.html
          html = html.replaceAll('{{data}}', '')

          if (this.mail.button_text != null) {
            html = html.replaceAll('{{button}}', '<a href="' + this.mail.button_url + '" id="ctl00_lnkArticle" target="IEXAds" class="articlebutton">' + this.mail.button_text + '</a><br /><br />')
          } else {
            html = html.replaceAll('{{button}}', '')
          }
          html = html.replaceAll('{{text}}', this.mail.text)
          html = html.replaceAll('{{greeting}}', this.mail.greeting)
          html = html.replaceAll('{{bye}}', this.mail.bye)
          html = html.replaceAll('{{person}}', this.mail.person)
          html = html.replaceAll('{{title}}', this.mail.subject)
          html = html.replaceAll('{{date}}', this.moment().format('LL'))

          if (this.emails.length > 0) {
            var firstEmail = this.emails[0]
            html = html.replaceAll('{{name}}', firstEmail.name)
            html = html.replaceAll('{{email}}', firstEmail.email)
          }

          this.html = html
        }
      },
      submitSettings (submit) {
        var settings = submit.item
        settings.siteId = this.site
        if (this.settings) {
          this.api.post('mail/settings', settings)
            .then(result => {
              this.settings = settings
              submit.done()
            }, error => {
              this.error = error
              submit.done()
            })
        }
      },
      sendMail () {
        if (this.$refs.form.validate()) {
          this.currentSend = (done) => this.send(done)
          this.$refs.yesno.open(`Send mail: ${this.mail.subject}`, `Are you sure you want to send this mail to ${this.emails.length} recipients?`)
        }
      },
      send (done) {
        var request = {
          emails: this.emails,
          mailBody: this.mail
        }
        this.api.post('mail/send/' + this.site, request)
          .then(result => {
            this.message = result.data
            done()
          }, error => {
            this.error = error
            done()
          })
      }
    }
  }
</script>
